import { ProgressBarStepType } from "../components/ProgressBars";
import {
  PersonalAutoQuickStep,
  PersonalAutoStep,
  HomeownerQuickStep,
  HomeownerStep
} from "../types/enums";
import routes from "../routes/routes";

export const PERSONAL_AUTO_QUICK_STEPS: ProgressBarStepType[] = [
  {
    step: PersonalAutoQuickStep.PolicyGeneral,
    icon: "profile",
    title: "Policy General",
    route: routes.quotes.auto.quick.policyGeneral
  },
  {
    step: PersonalAutoQuickStep.DriverDetail,
    icon: "plus-circle",
    title: "Drivers",
    route: routes.quotes.auto.quick.driverDetail
  },
  {
    step: PersonalAutoQuickStep.VehicleDetail,
    icon: "car",
    title: "Vehicles",
    route: routes.quotes.auto.quick.vehicleDetail
  },
  {
    step: PersonalAutoQuickStep.EstimatedPremium,
    icon: "dollar-circle",
    title: "Estimated Premium",
    route: routes.quotes.auto.quick.estimatedPremium
  }
];

export const PERSONAL_AUTO_STEPS: ProgressBarStepType[] = [
  {
    step: PersonalAutoStep.PolicyGeneral,
    icon: "profile",
    title: "Policy General",
    route: routes.quotes.auto.policyGeneral
  },
  {
    step: PersonalAutoStep.InsuredInformation,
    icon: "info-circle",
    title: "Insured Information",
    route: routes.quotes.auto.insuredInformation
  },
  {
    step: PersonalAutoStep.QualificationQuestions,
    icon: "question-circle",
    title: "Underwriting Questions",
    route: routes.quotes.auto.qualificationQuestions
  },
  {
    step: PersonalAutoStep.DriverDetail,
    icon: "plus-circle",
    title: "Driver Detail",
    route: routes.quotes.auto.driverDetail
  },
  {
    step: PersonalAutoStep.VehicleDetail,
    icon: "car",
    title: "Vehicle Detail",
    route: routes.quotes.auto.vehicleDetail
  },
  {
    step: PersonalAutoStep.PaymentPlans,
    icon: "dollar-circle",
    title: "Payment Plans",
    route: "TODO"
  }
];

export const HOMEOWNER_QUICK_STEPS: ProgressBarStepType[] = [
  {
    step: HomeownerQuickStep.PolicyGeneral,
    icon: "profile",
    title: "Policy General",
    route: routes.quotes.homeowner.quick.policyGeneral
  },
  {
    step: HomeownerQuickStep.Coverages,
    icon: "plus-circle",
    title: "Coverages",
    route: routes.quotes.homeowner.quick.coverage
  },
  {
    step: HomeownerQuickStep.EstimatedPremium,
    icon: "dollar-circle",
    title: "Estimated Premium",
    route: routes.quotes.homeowner.quick.estimate
  }
];

export const HOMEOWNER_STEPS: ProgressBarStepType[] = [
  {
    step: HomeownerStep.PolicyGeneral,
    icon: "profile",
    title: "Policy General",
    route: routes.quotes.homeowner.policyGeneral
  },
  {
    step: HomeownerStep.InsuredInformation,
    icon: "info-circle",
    title: "Insured Information",
    route: routes.quotes.homeowner.insuredInformation
  },
  {
    step: HomeownerStep.QualificationQuestions,
    icon: "question-circle",
    title: "Underwriting Questions",
    route: routes.quotes.homeowner.qualificationQuestions
  },
  {
    step: HomeownerStep.PropertyDetails,
    icon: "home",
    title: "Property Details",
    route: routes.quotes.homeowner.propertyDetails
  },
  {
    step: HomeownerStep.CoverageDetail,
    icon: "home",
    title: "Coverage Detail",
    route: routes.quotes.homeowner.detail
  },
  {
    step: HomeownerStep.AdditionalInterests,
    icon: "plus-circle",
    title: "Additional Interests",
    route: routes.quotes.homeowner.additionalInterests
  },
  {
    step: HomeownerStep.PaymentPlans,
    icon: "dollar-circle",
    title: "Payment Plans",
    route: "TODO"
  }
];
